export interface CelularPrefijoOption {
  label: string;
  value: string;
}

export const CELULAR_PREFIJOS: CelularPrefijoOption[] = [
  { label: '+54', value: '+54' },
  { label: 'BOL +591', value: '+591' },
  { label: 'BR +55', value: '+55' },
  { label: 'CH +56', value: '+56' },
  { label: 'COL +57', value: '+57' },
  { label: 'MX +52', value: '+52' },
  { label: 'PA +595', value: '+595' },
  { label: 'PER +51', value: '+51' },
  { label: 'UR +598', value: '+598' },
  { label: 'VE +58', value: '+58' },
];

export const CELULAR_PREFIJO_DEFAULT = '+54';
